import {
  ApolloClient,
  ApolloLink,
  concat,
  HttpLink,
  InMemoryCache,
} from "@noom/hive-core";
import { appConfig } from "src/config";
import { getAccessToken } from "src/utils/authCookieParser";

function getGraphQLAuthorizationHeader(useAccessToken = true) {
  let token = appConfig.LOGGED_OUT_BUYFLOW_CLIENT_TOKEN;
  if (useAccessToken) {
    token = getAccessToken() ?? appConfig.LOGGED_OUT_BUYFLOW_CLIENT_TOKEN;
  }
  if (token) {
    return `Bearer ${token}`;
  }
  return "";
}

const httpLink = new HttpLink({
  uri: appConfig.GRAPHQL_URL,
});

const getMiddleware = (useAccessToken = true) => {
  return new ApolloLink((operation, forward) => {
    // add the authorization to the headers
    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        Authorization: getGraphQLAuthorizationHeader(useAccessToken),
      },
    }));

    return forward(operation);
  });
};

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(getMiddleware(), httpLink),
});

export const apolloClientLoggedOutToken = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(getMiddleware(false), httpLink),
});
